import { isOverrideableDocFilterTypeId, SortTypeIds } from "../models/stores/ui-types";
import { isTranslationKey, translate } from "./translation/translate";
import { upperWords } from "./string-utils";
/**
 * Maps sort type IDs (used in PrimarySortType) to translation keys.
 * Most sort types use their ID as the key, but some have namespaced keys
 * to avoid collisions with other uses of the same term.
 */
export const SORT_TYPE_TO_TRANSLATION_KEY = {
    Group: "studentGroup",
    Name: "sortLabel.sortByOwner",
    Date: "sortLabel.sortByDate",
    Strategy: "strategy",
    Bookmarked: "bookmarked",
    Tools: "tools",
    Problem: "contentLevel.problem"
};
/**
 * Get the translation key for a sort type ID.
 */
export function getSortTypeTranslationKey(sortType) {
    var _a;
    return (_a = SORT_TYPE_TO_TRANSLATION_KEY[sortType]) !== null && _a !== void 0 ? _a : sortType;
}
export const FILTER_TYPE_TO_TRANSLATION_KEY = {
    Problem: "contentLevel.problem",
    Investigation: "contentLevel.investigation",
    Unit: "contentLevel.unit"
};
export function getFilterTypeTranslationKey(filterType) {
    return isOverrideableDocFilterTypeId(filterType)
        ? FILTER_TYPE_TO_TRANSLATION_KEY[filterType]
        : filterType;
}
/**
 * Get the display label for a doc-filter scope, applying any unit term override
 * (e.g. "Problem" -> "Model"). Non-overrideable scopes like "All" are returned as-is.
 */
export function getFilterTypeDisplayLabel(filterType) {
    const key = getFilterTypeTranslationKey(filterType);
    return isTranslationKey(key) ? upperWords(translate(key)) : filterType;
}
export function isValidSortTypeId(value) {
    return SortTypeIds.includes(value);
}
/**
 * Escape a translation key for use with React Hook Form.
 * RHF interprets dots as nested object paths, so we convert dots to underscores.
 */
export function escapeKeyForForm(key) {
    return key.replace(/\./g, "_");
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29ydC11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvc29ydC11dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQ1UsNkJBQTZCLEVBQTJDLFdBQVcsRUFDbkcsTUFBTSwyQkFBMkIsQ0FBQztBQUNuQyxPQUFPLEVBQUUsZ0JBQWdCLEVBQUUsU0FBUyxFQUFzQixNQUFNLHlCQUF5QixDQUFDO0FBQzFGLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUU1Qzs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sNEJBQTRCLEdBQTJDO0lBQ2xGLEtBQUssRUFBRSxjQUFjO0lBQ3JCLElBQUksRUFBRSx1QkFBdUI7SUFDN0IsSUFBSSxFQUFFLHNCQUFzQjtJQUM1QixRQUFRLEVBQUUsVUFBVTtJQUNwQixVQUFVLEVBQUUsWUFBWTtJQUN4QixLQUFLLEVBQUUsT0FBTztJQUNkLE9BQU8sRUFBRSxzQkFBc0I7Q0FDaEMsQ0FBQztBQUVGOztHQUVHO0FBQ0gsTUFBTSxVQUFVLHlCQUF5QixDQUFDLFFBQW9COztJQUM1RCxPQUFPLE1BQUEsNEJBQTRCLENBQUMsUUFBUSxDQUFDLG1DQUFJLFFBQThCLENBQUM7QUFDbEYsQ0FBQztBQUVELE1BQU0sQ0FBQyxNQUFNLDhCQUE4QixHQUE0RDtJQUNyRyxPQUFPLEVBQUUsc0JBQXNCO0lBQy9CLGFBQWEsRUFBRSw0QkFBNEI7SUFDM0MsSUFBSSxFQUFFLG1CQUFtQjtDQUMxQixDQUFDO0FBRUYsTUFBTSxVQUFVLDJCQUEyQixDQUFDLFVBQXlCO0lBQ25FLE9BQU8sNkJBQTZCLENBQUMsVUFBVSxDQUFDO1FBQzlDLENBQUMsQ0FBQyw4QkFBOEIsQ0FBQyxVQUFVLENBQUM7UUFDNUMsQ0FBQyxDQUFDLFVBQWdDLENBQUM7QUFDdkMsQ0FBQztBQUVEOzs7R0FHRztBQUNILE1BQU0sVUFBVSx5QkFBeUIsQ0FBQyxVQUF5QjtJQUNqRSxNQUFNLEdBQUcsR0FBRywyQkFBMkIsQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUNwRCxPQUFPLGdCQUFnQixDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLFVBQVUsQ0FBQztBQUN6RSxDQUFDO0FBRUQsTUFBTSxVQUFVLGlCQUFpQixDQUFDLEtBQWE7SUFDN0MsT0FBTyxXQUFXLENBQUMsUUFBUSxDQUFDLEtBQW1CLENBQUMsQ0FBQztBQUNuRCxDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLGdCQUFnQixDQUFDLEdBQVc7SUFDMUMsT0FBTyxHQUFHLENBQUMsT0FBTyxDQUFDLEtBQUssRUFBRSxHQUFHLENBQUMsQ0FBQztBQUNqQyxDQUFDIn0=